import type { ReactNode } from 'react';
import type { IconProps } from '../Icon/Icon.types';
import type { ImageProps } from '../Image/Image.types';

export const CARD_TYPE = {
  ACTION: 'action',
  ACTION_INLINE_ICON: 'action-inline-icon',
  ACTION_IMAGE: 'action-image',
  ACTION_SMALL: 'action-small',
  BASIC: 'basic',
  NUMBERED: 'numbered',
  EVENT: 'event',
} as const;

export interface CardProps {
  /**
   * Sets the className for the card
   */
  className?: string;

  /**
   * Sets the text for the cta on the card
   */
  ctaText?: ReactNode;

  /**
   * Sets the heading text for the card
   */
  headingText?: ReactNode;

  /**
   * Sets the subheading text for the card
   */
  subheadingText?: ReactNode;

  /**
   * Sets the href for the card
   */
  href: string;

  /**
   * Sets the icon or image to display on the card
   */
  graphic?: IconProps | ImageProps;

  /**
   * Sets the lead text for the card
   */
  leadText?: ReactNode;

  /**
   * Sets the data-testid attribute
   */
  testid?: string;

  /**
   * Sets the type of card to render
   */
  type?: typeof CARD_TYPE[keyof typeof CARD_TYPE];
}
